var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/loadclient',["require", "exports", "common/parts", "models/socialnetwork", "services/httpclient"], function (require, exports, Parts, SocialNetwork, Http) {
    "use strict";
    var LoadClient = (function (_super) {
        __extends(LoadClient, _super);
        function LoadClient() {
            _super.apply(this, arguments);
        }
        LoadClient.prototype.process = function (symbol) {
            var _this = this;
            var service = new Http.Channel();
            service.getData("/api/contact/" + symbol, Http.ServiceTarget.portalApi)
                .then(function (data) {
                var contact = new SocialNetwork.Contact();
                contact.networkMemberId = data.networkMemberId;
                contact.organizationId = data.organizationId;
                contact.email = data.email;
                contact.name = data.name;
                contact.company = data.company;
                _this.output.call(contact);
            })
                .fail(function (error) {
                _this.error.call(error);
            });
        };
        return LoadClient;
    }(Parts.Part));
    return LoadClient;
});

